import { ReactElement } from 'react'
import { BrowserRouter, Navigate, Route, Routes } from 'react-router'
import { AUTH_TOKEN_KEY } from '../constants/auth'
import DistributorPage from '../../pages/DistributorPage.tsx'
import OrderHistoryPage from '../../pages/OrderHistory.tsx'
import CommissionPage from '../../pages/CommissionPage.tsx'
import GenealogyPage from '../../pages/GenealogyPage.tsx'
import LoginPage from '../../pages/LoginPage.tsx'
import ViewBADetailsPage from '../../pages/ViewBADetailsPage.tsx'
import HamburgerLayout from '../layout/hamburger/hamburger.layout.tsx'

const PrivateRoute = ({ children }: { children: ReactElement }) => {
    const token = typeof window !== 'undefined' ? localStorage.getItem(AUTH_TOKEN_KEY) : null

    if (!token) {
        return <Navigate to="/" replace />
    }

    return (
        <HamburgerLayout>
            {children}
        </HamburgerLayout>
    )
}

const DefaultRouter = () => {
    return (
        <BrowserRouter>
            <Routes>
                <Route path="/" element={<LoginPage />} />
                <Route
                    path="/mlm/distributor"
                    element={
                        <PrivateRoute>
                            <DistributorPage />
                        </PrivateRoute>
                    }
                />
                <Route
                    path="/mlm/orderhistory"
                    element={
                        <PrivateRoute>
                            <OrderHistoryPage />
                        </PrivateRoute>
                    }
                />
                <Route
                    path="/mlm/commission"
                    element={
                        <PrivateRoute>
                            <CommissionPage />
                        </PrivateRoute>
                    }
                />
                <Route
                    path="/mlm/genealogy"
                    element={
                        <PrivateRoute>
                            <GenealogyPage />
                        </PrivateRoute>
                    }
                />
                <Route
                    path="/viewba-details"
                    element={
                        <PrivateRoute>
                            <ViewBADetailsPage />
                        </PrivateRoute>
                    }
                />
                <Route path="*" element={<Navigate to="/" replace />} />
            </Routes>
        </BrowserRouter>
    )
}

export default DefaultRouter

